import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Stack } from '@mui/material';
import SpeedIcon from '@mui/icons-material/Speed';
import VerifiedIcon from '@mui/icons-material/Verified';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import SchoolIcon from '@mui/icons-material/School';
import GroupIcon from '@mui/icons-material/Group';
import SecurityIcon from '@mui/icons-material/Security';

const features = [
  {
    icon: <SpeedIcon sx={{ fontSize: 40 }} />,
    title: 'Lightning Fast Generation',
    description: 'Create comprehensive exams in minutes. Our AI analyzes your curriculum and generates perfectly aligned questions instantly.',
  },
  {
    icon: <VerifiedIcon sx={{ fontSize: 40 }} />,
    title: 'Curriculum Aligned',
    description: 'Questions are generated to match your specific syllabus, ensuring complete coverage of learning objectives and standards.',
  },
  {
    icon: <AutoGraphIcon sx={{ fontSize: 40 }} />,
    title: 'Difficulty Calibration',
    description: 'Intelligent difficulty rating ensures balanced assessments with appropriate challenge levels for your students.',
  },
  {
    icon: <SchoolIcon sx={{ fontSize: 40 }} />,
    title: 'Multiple Question Types',
    description: 'Generate MCQs, extended response, and multi-part questions. Complete with marking schemes and model answers.',
  },
  {
    icon: <GroupIcon sx={{ fontSize: 40 }} />,
    title: 'Collaborative Platform',
    description: 'Share question banks with colleagues, review and refine content together, and maintain consistency across departments.',
  },
  {
    icon: <SecurityIcon sx={{ fontSize: 40 }} />,
    title: 'Secure & Private',
    description: 'Your content is encrypted and secure. Full control over who can access your exams and question banks.',
  },
];

const Features = () => {
  return (
    <Box sx={{ py: 10, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        <Stack spacing={6} alignItems="center">
          <Box textAlign="center">
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                fontWeight: 700,
                mb: 2,
              }}
            >
              Everything You Need to Create Better Exams
            </Typography>
            <Typography
              variant="h6"
              color="text.secondary"
              sx={{ maxWidth: '700px', mx: 'auto' }}
            >
              Powerful features designed specifically for educators who want to save time 
              while maintaining the highest standards of assessment quality.
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {features.map((feature, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    height: '100%',
                    p: 3,
                    transition: 'all 0.3s ease',
                    border: '1px solid',
                    borderColor: 'divider',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 24px rgba(0,0,0,0.1)',
                      borderColor: 'primary.main',
                    },
                  }}
                >
                  <CardContent>
                    <Stack spacing={2}>
                      <Box sx={{ color: 'primary.main' }}>
                        {feature.icon}
                      </Box>
                      <Typography variant="h6" fontWeight={600}>
                        {feature.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {feature.description}
                      </Typography>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Stack>
      </Container>
    </Box>
  );
};

export default Features;